import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Skillkafe',
    description: "Job-ready courses for corporate roles in Banking, Automobile and Retail, with placement assistance for job seekers across India's tier 2 and tier 3 cities.",
    placeholder: 'Empowering careers with industry-ready skills for a brighter future.',
    url: getOrigin(),
    ogImage: 'https://skillkafe.cdn.modulify.website/images/share/skillkafe-share.jpg'
}
